import Cookies from 'universal-cookie';

export const OKTA_JWT_ACCESS_TOKEN = 'OKTA_JWT_ACCESS_TOKEN';
export const OKTA_JWT_ACCESS_UID = 'OKTA_JWT_ACCESS_UID';
// Legacy: read-only fallback so pre-switch logins keep their analytics id; remove after ForgeRock cutoff (2026-10-31).
export const SAM_JWT_ACCESS_UID = 'SAM_JWT_ACCESS_UID';
export const SELECTED_DATABASE = 'selected_database';
export const IMPACT_FEATURE_FLAGS = 'impactFeatureFlags';

export const DEFAULT_THEME_COOKIE_OBJECT = '{ "isDarkModeEnabled": true }';

export const cookies = new Cookies();

export const getCookie = (name: string) => {
  const value = new RegExp(`(^|;) ?${name}=([^;]*)(;|$)`).exec(document.cookie);

  return value !== null ? value[2] : null;
};

export const setCookie = (cookie: string) => {
  const hostname = window.location.hostname;
  const domain = hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1);
  document.cookie = `${cookie};path=/;domain=${domain}`;
};
